import React, { useEffect, useState } from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Grid,
  FormHelperText,
  Divider,
  Button,
  Typography,
  styled,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import DeleteIcon from '@material-ui/icons/Delete'
import UpsertFileButton from '../../components/file_upload'
import FileWithContext from '../../models/file_with_context'

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    minWidth: '0',
  },
  '& .MuiInputBase-input': {
    height: 'unset',
  },
}))

const EmployeGardienRow = ({ index, remove, record }) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext()
  const variant = 'outlined'
  const role = watch(`rows[${index}].role`)
  const rowId = watch(`rows[${index}].id`)
  const [files, setFiles] = useState([])

  useEffect(() => {
    // get files for current staff
    const files_records = record.team_and_guards_documents?.filter(
      (document) => document.staff_id === rowId
    )
    setFiles(files_records)
  }, [record, rowId])

  return (
    <Box mb="1em">
      <Grid container alignItems="center">
        <Grid item xs={12} sm={4}>
          <FormControl
            variant="outlined"
            fullWidth
            error={!!errors?.rows?.[index]?.role}
          >
            <InputLabel>Choix {index + 1}</InputLabel>
            <Controller
              name={`rows[${index}].role`}
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Select
                  {...field}
                  label={`Choix ${index + 1}`}
                  style={{
                    minWidth: 0,
                  }}
                >
                  <MenuItem value="employe">Employé</MenuItem>
                  <MenuItem value="gardien">Gardien</MenuItem>
                </Select>
              )}
            />
            <FormHelperText>
              {errors?.rows?.[index]?.role?.message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name={`rows[${index}].nom`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <CustomTextField
                style={{
                  minWidth: 0,
                }}
                inputProps={{
                  style: {
                    height: 'unset',
                  },
                }}
                {...field}
                label={`Nom`}
                variant={variant}
                fullWidth
                error={!!errors?.rows?.[index]?.nom}
                helperText={errors?.rows?.[index]?.nom?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name={`rows[${index}].email`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <CustomTextField
                style={{
                  minWidth: 0,
                }}
                inputProps={{
                  style: {
                    height: 'unset',
                  },
                }}
                {...field}
                label={`Email`}
                variant={variant}
                fullWidth
                error={!!errors?.rows?.[index]?.email}
                helperText={errors?.rows?.[index]?.email?.message}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Controller
            name={`rows[${index}].tel`}
            control={control}
            defaultValue=""
            render={({ field }) => (
              <CustomTextField
                style={{
                  minWidth: 0,
                }}
                inputProps={{
                  style: {
                    height: 'unset',
                  },
                }}
                {...field}
                label={`Tel`}
                variant={variant}
                fullWidth
                error={!!errors?.rows?.[index]?.tel}
                helperText={errors?.rows?.[index]?.tel?.message}
              />
            )}
          />
        </Grid>
        {role === 'gardien' && (
          <Grid item xs={12} sm={4}>
            <FormControl
              variant="outlined"
              fullWidth
              error={!!errors?.rows?.[index]?.logement}
            >
              <InputLabel>Logement</InputLabel>
              <Controller
                name={`rows[${index}].logement`}
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Select {...field} label="Logement">
                    <MenuItem value="oui">Oui</MenuItem>
                    <MenuItem value="non">Non</MenuItem>
                  </Select>
                )}
              />
              <FormHelperText>
                {errors?.rows?.[index]?.logement?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} sm={12}>
          <UpsertFileButton
            defaultValue={files}
            linkable_type="copros"
            linkable_id={record.id}
            staff_id={rowId}
            copro_id={record.id}
            resource="file_with_context"
            basePath="file_with_context"
            documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
            issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
            saveResult={(result) => {
              const { accepted_files, rejected_files } = result
              if (rejected_files.length === 0 && accepted_files.length > 0) {
                setFiles([...accepted_files])
              }
            }}
            show_shared_select={true}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        container
        justifyContent="flex-end"
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        <Button onClick={() => remove(index)} variant="contained">
          <Typography>Supprimer</Typography>
          <DeleteIcon color="error" />
        </Button>
      </Grid>
      <Divider />
    </Box>
  )
}

export default EmployeGardienRow
